import index from '../index';
import MODULE_ID from '../moduleId';
import configMixin from '@/mixins/configMixin';
import dateUtils from '@/common/dateUtils';
import DefaultStrategy from '../dutyActivities/tenantStrategies/DefaultStrategy';
import LvbStrategy from '../dutyActivities/tenantStrategies/LvbStrategy';
import tenantStrategies from '../dutyActivities/tenantStrategies';
import dutyService from './dutyService';
import { DAY_IN_MS } from '@/common/constants';

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

const dutyMixin = {
  mixins: [configMixin],
  computed: {
    mx_moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    mx_moduleFlavour() {
      let flavour;
      if (this.mx_moduleConfig) {
        flavour = this.mx_moduleConfig.dutiesViewFlavour;
      }
      if (!flavour) {
        flavour = 'DutyList';
      }
      if (!['DutyCalendarRhbStyle', 'DutyList'].includes(flavour)) {
        flavour = 'DutyList'; // Set default if illegal configuration
      }
      console.debug('found flavour', flavour);
      return flavour;
    },
    mx_calDavLinkIsEnabled() {
      let isEnabled = false;
      if (this.mx_moduleConfig && this.mx_moduleConfig.calDavLinkIsEnabled) {
        isEnabled = this.mx_moduleConfig.calDavLinkIsEnabled;
      }
      return isEnabled;
    },
    firsOfCalendarMonth: {
      get() {
        return this.$store.state.meinDienst.firsOfCalendarMonth;
      },
      set(value) {
        this.$store.commit(`meinDienst/setFirsOfCalendarMonth`, value);
      },
    },
    currentMonth() {
      return this.firsOfCalendarMonth ? dateUtils.formatAsLocaleYearAndMonth(this.firsOfCalendarMonth) : null;
    },
  },
  methods: {
    dmx_markAsRead(displayedDocument) {
      let sendboxTitle = this.$t('action.read.msg', { object: displayedDocument.title });
      let snackbarText = this.$t('action.document.read');
      this.$store.dispatch(
        `sendbox/markAsRead2`,
        {
          item: displayedDocument,
          sendboxTitle,
          snackbarText,
          immediate: true,
        },
        { root: true }
      );
    },
    selectToday() {
      let today = new Date();
      today.setDate(1);
      this.firsOfCalendarMonth = today;
    },
    nextMonth() {
      let firstOfMonth = this.firsOfCalendarMonth;
      let nextMonth = new Date(firstOfMonth.getTime() + DAY_IN_MS * 33);
      nextMonth.setDate(1);
      this.firsOfCalendarMonth = nextMonth;
    },
    previousMonth() {
      let firstOfMonth = this.firsOfCalendarMonth;
      let nextMonth = new Date(firstOfMonth.getTime() - DAY_IN_MS * 20);
      nextMonth.setDate(1);
      this.firsOfCalendarMonth = nextMonth;
    },
    mx_time(minutesAfterMidnight, d) {
      let dateString = d.day ? dateUtils.reformatDateIsoStringAsYYYYMMDD(d.day) : '';
      return minutesAfterMidnight ? dateUtils.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight, dateString) : 'na';
    },
    mx_getDutyDate(duty) {
      if (!duty) return '';
      let date = dateUtils.parseISOString(duty.day);
      return dateUtils.formatWithMonthNameAndShortWeekday(date, this.$store.state.language.locale);
    },
    mx_getDutyTime(duty) {
      if (!duty) return '';
      return `${duty._startMinutesAfterMidnight ? this.mx_getDutyStartTime(duty) + '-' : ''}${
        duty._endMinutesAfterMidnight ? this.mx_getDutyEndTime(duty) : ''
      }`;
    },
    mx_getDutyStartTime(duty) {
      if (!duty) return '';
      return duty._startMinutesAfterMidnight ? this.mx_time(duty._startMinutesAfterMidnight, duty) : '';
    },
    mx_getDutyEndTime(duty) {
      if (!duty) return '';
      return duty._endMinutesAfterMidnight ? this.mx_time(duty._endMinutesAfterMidnight, duty) : '';
    },
    mx_getDutyColor(duty) {
      let timed = duty._startMinutesAfterMidnight && duty._endMinutesAfterMidnight;
      return timed ? this.mx_timedDutyColor : this.mx_dutyColor;
    },
    /**
     * Find all dutyActivities related to the given duty (id and date=day field).
     *
     * @param {*} duty
     * @param {*} param1
     * @returns
     */
    mx_getDutyActivities(duty, { tenant } = {}) {
      if (!duty) return [];
      let moduleConfig = this.mx_moduleConfig;
      let allDutyActivities = this.$store.state.meinDienst.dutyActivities;
      // console.debug("mx_getDutyActivities",allDutyActivities.length)
      let dutyActivities = allDutyActivities
        .filter((da) => {
          // console.debug('compare dutyActivity dates', da.dutyIdFk, duty.id, da.day, duty.day);
          return true;
        })
        .filter((da) => da.dutyIdFk === duty.id && dateUtils.isSameDateIsoString(da.day, duty.day))

        .sort((da1, da2) => {
          if (da1.day !== da2.day) {
            // should always be unique
            let time1 = Date.parse(da1.day);
            let time2 = Date.parse(da2.day);
            return time1 > time2 ? 1 : -1;
          }
          let timeDiff = da1.fromMinutesAfterMidnight - da2.fromMinutesAfterMidnight;
          return timeDiff > 0 ? 1 : timeDiff < 0 ? -1 : 0;
        })
        .map((da) => {
          let { dutyActivityType, dutyActivityGroup } = dutyService.getActivityGroup({
            moduleConfig,
            dutyActivity: da,
          });
          da._dutyActivityType = dutyActivityType;
          da._dutyActivityGroup = dutyActivityGroup;
          return da;
        });

      let merged = [];

      let accumulator;

      dutyActivities = tenantStrategies.preProcessDutyActivities({ tenant, moduleConfig, dutyActivities });

      for (let i = 0; i < dutyActivities.length; i++) {
        let currentDutyActivity = dutyActivities[i];

        let advice = tenantStrategies.shouldMergeDutyActivity({
          tenant,
          moduleConfig,
          accumulator,
          currentDutyActivity,
          dutyActivities,
          currentIndex: i,
        });
        // console.debug("shouldMegeDutyActivity ",advice)
        if (advice === 'mergeToAccumulator') {
          if (accumulator) {
            let da2 = currentDutyActivity;

            // save merged items within children attribute
            // // console.debug("save merged items within children attribute")
            if (!accumulator.children) accumulator.children = [];
            accumulator.children.push(currentDutyActivity);

            accumulator.endStopIdFk = da2.endStopIdFk;
            accumulator.toMinutesAfterMidnight = da2.toMinutesAfterMidnight;
            accumulator._endStop = da2._endStop;
          } else {
            accumulator = clone(currentDutyActivity);
            accumulator.id += '_';
            accumulator.children = [currentDutyActivity];
          }
        } else if (advice === 'new') {
          // finally execute merge and start new 'card'

          merged.push(accumulator);
          accumulator = clone(currentDutyActivity);
          accumulator.id += '_';
          accumulator.children = [currentDutyActivity];
        } else if (advice === 'ignore') {
          // console.debug('ignore dutyActivity',currentDutyActivity)
        }
      }
      if (accumulator) {
        merged.push(accumulator);
      }

      // remove unused chains
      // first, if configured, filter and merge dutyActivities to build a chain (overlapping activities to be avoided
      if (moduleConfig.buildNonOverlappingChain && accumulator.children) {
        const buildNonOverlappingChain = true;
        merged.forEach((activity) => {
          if (activity.children) {
            activity.children = dutyService.filterAndMergeDutyActivities(activity.children, buildNonOverlappingChain);
          }
        });
      }

      return merged;
    },
  },
};
export default dutyMixin;
